import {
  READ_ACTION,
  DASHBOARD_FTR_INVEST,
  SUBSCRIPTION_REPLACEMENTS_STATICS,
  DASHBOARD_CX,
  DASHBOARD_FRANQ_FINDER,
} from "@/constants/resources";
import { infoKPI } from "@/helpers/modalInfo";

export default [
  {
    path: "/kpi-founders/dashboard-ftr-invest",
    name: "dashboard-ftr-invest",
    component: () => import("@/modules/kpi_founders/views/DashboardFtrInvest.vue"),
    meta: {
      resource: DASHBOARD_FTR_INVEST,
      action: READ_ACTION,
      pageTitle: "Dashboard FTR Invest",
    },
  },
  {
    path: "/kpi-founders/troca-assinatura",
    name: "kpi-subscription-replacements-statics",
    component: () => import("@/modules/kpi_founders/views/KpiSubscriptionsReplacements.vue"),
    meta: {
      resource: SUBSCRIPTION_REPLACEMENTS_STATICS,
      action: READ_ACTION,
      pageTitle: "Troca de Assinatura",
    },
  },
  {
    path: "/kpi-founders/dashboard-cx",
    name: "dashboard-cx",
    component: () => import("@/modules/kpi_founders/views/DashboardCx.vue"),
    meta: {
      resource: DASHBOARD_CX,
      action: READ_ACTION,
      pageTitle: "Dashboard CX",
    },
  },
  {
    path: "/kpi-founders/gestao-franq-finder",
    name: "dashboard-franq-finder",
    component: () => import("@/modules/kpi_founders/views/DashboardFranqFinder.vue"),
    meta: {
      resource: DASHBOARD_FRANQ_FINDER,
      action: READ_ACTION,
      pageTitle: "Gestão Franq Finder",
    },
  },
];
